import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { SecurityTokenRequest } from './securitytokenrequest';

export class SecurityTokenAPI extends APIImpl<SecurityTokenRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/security-token
        return "security-token";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenapi.tsx